import { VerticalScrollMaskPosition } from './vertical-scroll.types';

export const MASK_POSITION_TOP: VerticalScrollMaskPosition = 'top';
export const MASK_POSITION_BOTTOM: VerticalScrollMaskPosition = 'bottom';
